import React from "react";
var stopPropagation = function (e) { return e.stopPropagation(); };
export var RowClickBoundary = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("span", { role: "presentation", className: className, onClick: stopPropagation }, children));
};
